import './css/about.css';
import { Link } from 'react-router-dom';

const About = () => {
    const name = process.env.REACT_APP_APP_NAME || "ExamWorld";
    
    return (
        <div className="aboutPageWrapper">
            
            {/* --- Hero Section --- */}
            <section className="aboutHeroSection">
                <div className="aboutHeroContent">
                    <h1 className="aboutHeroTitle">Master Your Exams. Protect Your Peace.</h1>
                    <p className="aboutHeroDescription">
                        {name} is a comprehensive exam preparation platform designed to help you succeed. 
                        We combine premium mock tests, detailed analytics, and previous year papers with a 
                        stress-free learning environment, so you can achieve your goals without burning out.
                    </p>
                    <div className="aboutHeroActions">
                        <Link to="/test" className="primaryBtn">Start Practicing</Link>
                    </div>
                </div>
            </section>

            {/* --- Mission & Vision --- */}
            <section className="aboutGridSection">
                <div className="aboutCard">
                    <div className="aboutIcon"><i className="fa-solid fa-bullseye"></i></div>
                    <h3>Our Mission</h3>
                    <p>
                        To democratize quality exam preparation by providing every student—regardless of their location—access to high-quality mock tests, accurate evaluation, and a supportive digital environment.
                    </p>
                </div>
                <div className="aboutCard">
                    <div className="aboutIcon"><i className="fa-regular fa-eye"></i></div>
                    <h3>Our Vision</h3>
                    <p>
                        A learning ecosystem where students can confidently prepare for competitive exams with access to personalized analytics, ensuring academic excellence alongside mental resilience.
                    </p>
                </div>
            </section>

            {/* --- Core Features (Replaced over-promising medical/VR features) --- */}
            <section className="aboutFeaturesSection">
                <div className="aboutSectionHeader">
                    <h2>What Makes Us Different?</h2>
                    <p>Everything you need to clear your exams, built into one seamless platform.</p>
                </div>
                <div className="aboutFeaturesGrid">
                    <div className="aboutFeatureCard">
                        <i className="fa-solid fa-laptop-code featureIcon"></i>
                        <h4>Real Exam Experience</h4>
                        <p>Practice with timer-based mock tests that simulate the exact environment of competitive exams.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <i className="fa-solid fa-chart-pie featureIcon"></i>
                        <h4>Detailed Analytics</h4>
                        <p>Track your right and wrong attempts, understand negative marking impacts, and monitor your overall progress.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <i className="fa-solid fa-file-lines featureIcon"></i>
                        <h4>Previous Year Papers</h4>
                        <p>Access a vast library of verified previous year question papers to understand exam patterns perfectly.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <i className="fa-solid fa-leaf featureIcon"></i>
                        <h4>Stress-Free Interface</h4>
                        <p>A clean, distraction-free environment designed to reduce eye strain and cognitive load during long study sessions.</p>
                    </div>
                </div>
            </section>

            {/* --- Target Audience --- */}
            <section className="aboutAudienceSection">
                <div className="aboutSectionHeader">
                    <h2>Who We Serve</h2>
                </div>
                <div className="aboutGridSection">
                    <div className="aboutCard">
                        <div className="aboutIcon"><i className="fa-solid fa-landmark"></i></div>
                        <h4>Government Job Aspirants</h4>
                        <p>Targeted practice for major competitive and recruitment exams with accurate syllabus coverage.</p>
                    </div>
                    <div className="aboutCard">
                        <div className="aboutIcon"><i className="fa-solid fa-graduation-cap"></i></div>
                        <h4>College Entrance Seekers</h4>
                        <p>Subject-wise tests and comprehensive series to help you secure a seat in your dream institution.</p>
                    </div>
                </div>
            </section>

            {/* --- Core Values --- */}
            <section className="aboutValuesSection">
                <div className="aboutSectionHeader">
                    <h2>Our Core Values</h2>
                </div>
                <div className="aboutFeaturesGrid">
                    <div className="aboutFeatureCard">
                        <h4><i className="fa-solid fa-check-double textPrimary"></i> Accuracy</h4>
                        <p>We ensure every question and answer key is rigorously verified.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <h4><i className="fa-solid fa-hand-holding-heart textPrimary"></i> Empathy</h4>
                        <p>Building tools that understand and reduce student anxiety.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <h4><i className="fa-solid fa-lightbulb textPrimary"></i> Innovation</h4>
                        <p>Continuously improving our evaluation metrics and platform speed.</p>
                    </div>
                    <div className="aboutFeatureCard">
                        <h4><i className="fa-solid fa-users textPrimary"></i> Accessibility</h4>
                        <p>Making premium test prep affordable and available to everyone.</p>
                    </div>
                </div>
            </section>

            {/* --- CTA Section --- */}
            <section className="aboutCtaSection">
                <h2>Ready to Elevate Your Preparation?</h2>
                <p>Join thousands of students testing their knowledge and improving daily.</p>
                <div className="aboutHeroActions">
                    <Link to="/contact" className="secondaryBtn">Contact Support</Link>
                </div>
            </section>
        </div>
    );
};

export default About;